import React from 'react';
import { useSelector } from 'react-redux'
import { selectAboutPage } from '../languages/languagesSlice'

const root = process.env.PUBLIC_URL

export const About = () => {
  const msg = useSelector(selectAboutPage)

  return (
    <section className="container">
      <h1>{msg.introduction}</h1>
      <p className="indent">{msg.introductionParagraphy1}</p>
      <br/>
      <h1>{msg.history}</h1>
      <p className="indent mb-1">{msg.historyParagraphy1}</p>
      <p className="indent mb-1">{msg.historyParagraphy2}</p>
      <h1>{msg.links}</h1>
      <p className="indent mb-1">{msg.linksParagraphy1}</p>
      <div className="social-icons">
        <a href="https://facebook.com/Fun-Fun-Vietnam-231470040917691" target="_blank"><img className="social-icon" src={`${root}/assets/icons/facebook.png`} /></a>
        <a href="https://instagram.com/funfunvietnam.1024" target="_blank"><img className="social-icon" src={`${root}/assets/icons/instagram.png`} /></a>
        <a href="https://www.youtube.com/channel/UCmyrLogK8_C-EMa3rzMfHlQ/" target="_blank"><img className="social-icon" src={`${root}/assets/icons/youtube.png`} /></a>
      </div>
      <div className="footer">
        <h1>Fun Fun Vietnam</h1>
        <a href="https://funfunvietnam.com/" target="_blank">https://funfunvietnam.com/</a>
      </div>
    </section>
  )
}

export default About